import { FC, SVGProps } from "react";

interface EyeSvgProps extends SVGProps<SVGSVGElement> {
  color?: string;
  crossed?: boolean;
}

const EyeSvg: FC<EyeSvgProps> = ({ crossed = false, ...props }) => {
  if (crossed) {
    return (
      <svg
        width={22}
        height={22}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.3447 12.4278C12.7584 13.4163 11.6197 13.9365 10.4887 13.7325C9.35767 13.5285 8.47243 12.6433 8.26845 11.5122C8.06446 10.3812 8.58466 9.2425 9.57317 8.65625"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4964 15.581C14.9153 16.7802 12.9839 17.4266 10.9995 17.4205C7.71134 17.479 4.67318 15.6719 3.15508 12.7546C2.60976 11.6492 2.60976 10.3531 3.15508 9.24777C3.91431 7.73584 5.12459 6.49719 6.61852 5.70312"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7237 12.9594C18.7605 12.8897 18.8084 12.8272 18.8432 12.7561C19.3885 11.6508 19.3885 10.3547 18.8432 9.24935C17.3251 6.33198 14.2869 4.52486 10.9987 4.58341C10.7926 4.58341 10.5922 4.61092 10.3887 4.62433"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.2519 18.3359L3.66211 2.74609"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M14.1233 10.3798C15.2943 11.5508 15.2943 13.4518 14.1233 14.6248C12.9523 15.7958 11.0512 15.7958 9.87825 14.6248C8.70725 13.4538 8.70725 11.5527 9.87825 10.3798C11.0512 9.20675 12.9512 9.20675 14.1233 10.3798"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12.5C3 11.841 3.152 11.189 3.446 10.588V10.588C4.961 7.491 8.309 5.5 12 5.5C15.691 5.5 19.039 7.491 20.554 10.588V10.588C20.848 11.189 21 11.841 21 12.5C21 13.159 20.848 13.811 20.554 14.412V14.412C19.039 17.509 15.691 19.5 12 19.5C8.309 19.5 4.961 17.509 3.446 14.412V14.412C3.152 13.811 3 13.159 3 12.5Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeSvg;
